import React from 'react';
import { Phone, MessageCircle, Euro } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY_INFO } from '../../mock';

export const KostenSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Kosten
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Kosten & Kostenübernahme
          </h2>
          
          {/* AI-Kurzantwort-Box */}
          <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-xl p-5 mb-8 max-w-3xl mx-auto text-left">
            <p className="text-sm font-semibold text-brand-green-dark mb-2">Wichtig zu wissen:</p>
            <p className="text-gray-700 leading-relaxed text-[15px]">
              Bei einem unverschuldeten Unfall werden die Kosten für ein unabhängiges Unfallgutachten in der Regel von der gegnerischen Haftpflichtversicherung übernommen – abhängig vom jeweiligen Einzelfall.
            </p>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg">
          <div className="flex items-start gap-6 mb-8">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center border border-brand-green/15">
                <Euro className="w-8 h-8 text-brand-green" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Wer trägt die Kosten?</h3>
              <p className="text-gray-700 leading-relaxed text-lg mb-4">
                Bei einem <strong>unverschuldeten Unfall</strong> werden die Gutachterkosten <strong>in der Regel von der gegnerischen Haftpflichtversicherung übernommen</strong> – je nach Einzelfall und Schadensituation.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Als Geschädigter haben Sie das Recht auf freie Gutachterwahl. Sie müssen in den meisten Fällen nicht in Vorleistung gehen.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6">
            <p className="text-sm text-gray-600 leading-relaxed">
              <strong>Wichtig:</strong> Die Kostenübernahme ist abhängig von der Schadenssituation und den individuellen Umständen. Diese Information stellt keine rechtsverbindliche Zusage dar. Wir klären Ihre konkrete Situation gerne im Gespräch.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};